// extracted by mini-css-extract-plugin
export default {"quantity_container":"iI","hiddenflavorstring":"jI","loadingLine":"kI","productimgwrap":"lI","productimg":"mI","circlepic":"nI","productinfo":"oI","grey_x":"pI","cartrow":"qI","bold":"rI","title":"sI","blue":"tI","strike":"uI","flexgap":"vI","flavorstring":"wI","nodecorate":"xI","flavorstring_link":"yI","rdstring":"zI","removeditemblock":"AI","removed_heading":"BI","removed_text":"CI","addback":"EI"};
    if(module.hot) {
      // 1743628927280
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  